import React from 'react';

import { useField } from 'formik';
import { Form } from 'react-bootstrap';

import { ITextAreaProps } from 'components/UI/TextArea';
import { TextArea } from 'components/UI';
import regex from 'constants/regex';

export interface ITextAreaFieldProps extends ITextAreaProps {
  name: string;
  useEmoji?: boolean;
}

const TextAreaField = ({ useEmoji, ...props }: ITextAreaFieldProps) => {
  const [field, meta, helpers] = useField(props.name);
  const invalid = meta.touched && meta.error ? true : false;
  const { setValue, setTouched } = helpers;

  const onChange = (value: string) => {
    let newValue = value;
    if (!useEmoji) {
      newValue = newValue.replace(regex.emoji, '');
    }
    setValue(newValue);
  };

  return (
    <>
      <TextArea
        {...props}
        value={field.value}
        onBlur={() => setTouched(true)}
        onChange={(e) => onChange(e.target.value)}
      />
      {invalid && (
        <Form.Control.Feedback className="d-block" type="invalid">
          {meta.error}
        </Form.Control.Feedback>
      )}
    </>
  );
};

export default TextAreaField;
